<div class="prompt-item-content">
	<div>
		<div class="prompt-item-title">{{ prompt.title }}</div>
		<div class="prompt-item-complete-prompt">{{ prompt.fullPrompt }}</div>
	</div>
	<div *ngIf="isHovering">
		<button *ngIf="canDelete" class="delete-button" style="cursor: pointer;" (click)="deletePrompt($event, prompt.promptId)">
			<i class="fa-duotone fa-trash"></i>
		</button>
	</div>
</div>